import React from 'react'
import { SectionHeader } from '@/components/molecules/SectionHeader'
import { Text } from '@/components/atoms/Text'
import { Question } from '@/components/molecules/Question'
import { Button } from '@/components/molecules/Button'
import './QuestionsSection.css'

import userGroupIcon from '@/assets/user_group_icon.svg'

export interface QuestionsSectionProps {
  className?: string
}

const questions = [
  'What type design will help me to increase revenue ?',
  'Why are the users not retaining ?',
  'How do I ensure faster execution from my engineers ?',
  'What will be a future proof architecture for my product ?',
  'How do I increase engagement of customers with AI',
  'How do I simplify onboarding without loosing users?',
]

export const QuestionsSection: React.FC<QuestionsSectionProps> = ({
  className = '',
}) => {
  return (
    <section className={`questions-section ${className}`}>
      <SectionHeader title={<>Building High Impact <br /> digital products</>} />

      <div className="questions-section-content">
        <div className="questions-row questions-row-top">
          {questions.slice(0, 3).map((question, index) => (
            <Question key={index} text={question} />
          ))}
        </div>
        <div className="questions-row questions-row-bottom">
          {questions.slice(3, 6).map((question, index) => (
            <Question key={index + 3} text={question} />
          ))}
        </div>
      </div>

      <div className="questions-section-cta">
        <Text size="base" color="primary" weight="bold" className="questions-section-cta-text">
          Have questions ?
        </Text>
        <div className="questions-section-buttons">
          <Button
            label="Expert Review"
            iconSrc={userGroupIcon}
            iconAlt="Expert Review"
            href="https://docs.google.com/forms/d/13rU1q-xrGIBQL86oyoqqr3ps76M2zmmHA4V_RxLUxCM/edit"
            target="_blank"
            variant="primary"
          />
          {/* <Button
            label="Schedule a call"
            href="#ask-question"
            variant="outline"
            textSize="large"
            className="questions-section-button-outline"
          /> */}
        </div>
      </div>
    </section >
  )
}
